import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import HashMap from '../../../../java/util/HashMap';
import Coordinate from './Coordinate';
import Double from '../../../../java/lang/Double';
import Integer from '../../../../java/lang/Integer';
import Comparable from '../../../../java/lang/Comparable';
import Serializable from '../../../../java/io/Serializable';
var PrecisionModel = /*#__PURE__*/function () {
  function PrecisionModel() {
    _classCallCheck(this, PrecisionModel);
    PrecisionModel.constructor_.apply(this, arguments);
  }
  _createClass(PrecisionModel, [{
    key: "equals",
    value: function equals(other) {
      if (!(other instanceof PrecisionModel)) return false;
      var otherPrecisionModel = other;
      return this._modelType === otherPrecisionModel._modelType && this._scale === otherPrecisionModel._scale;
    }
  }, {
    key: "compareTo",
    value: function compareTo(o) {
      var other = o;
      var sigDigits = this.getMaximumSignificantDigits();
      var otherSigDigits = other.getMaximumSignificantDigits();
      return Integer.compare(sigDigits, otherSigDigits);
    }
  }, {
    key: "getScale",
    value: function getScale() {
      return this._scale;
    }
  }, {
    key: "isFloating",
    value: function isFloating() {
      return this._modelType === PrecisionModel.FLOATING || this._modelType === PrecisionModel.FLOATING_SINGLE;
    }
  }, {
    key: "getType",
    value: function getType() {
      return this._modelType;
    }
  }, {
    key: "toString",
    value: function toString() {
      var description = 'UNKNOWN';
      if (this._modelType === PrecisionModel.FLOATING) description = 'Floating';else if (this._modelType === PrecisionModel.FLOATING_SINGLE) description = 'Floating-Single';else if (this._modelType === PrecisionModel.FIXED) description = 'Fixed (Scale=' + this.getScale() + ')';
      return description;
    }
  }, {
    key: "makePrecise",
    value: function makePrecise() {
      if (typeof arguments[0] === 'number') {
        var val = arguments[0];
        if (Double.isNaN(val)) return val;
        if (this._modelType === PrecisionModel.FLOATING_SINGLE) {
          var floatSingleVal = val;
          return floatSingleVal;
        }
        if (this._modelType === PrecisionModel.FIXED) return Math.round(val * this._scale) / this._scale;
        return val;
      } else if (arguments[0] instanceof Coordinate) {
        var coord = arguments[0];
        if (this._modelType === PrecisionModel.FLOATING) return null;
        coord.x = this.makePrecise(coord.x);
        coord.y = this.makePrecise(coord.y);
      }
    }
  }, {
    key: "getMaximumSignificantDigits",
    value: function getMaximumSignificantDigits() {
      var maxSigDigits = 16;
      if (this._modelType === PrecisionModel.FLOATING) maxSigDigits = 16;else if (this._modelType === PrecisionModel.FLOATING_SINGLE) maxSigDigits = 6;else if (this._modelType === PrecisionModel.FIXED) maxSigDigits = 1 + Math.trunc(Math.ceil(Math.log(this.getScale()) / Math.log(10)));
      return maxSigDigits;
    }
  }, {
    key: "setScale",
    value: function setScale(scale) {
      this._scale = Math.abs(scale);
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [Serializable, Comparable];
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      this._modelType = null;
      this._scale = null;
      if (arguments.length === 0) this._modelType = PrecisionModel.FLOATING;else if (arguments.length === 1) if (arguments[0] instanceof Type) {
        var modelType = arguments[0];
        this._modelType = modelType;
        if (modelType === PrecisionModel.FIXED) this.setScale(1.0);
      } else if (typeof arguments[0] === 'number') {
        var scale = arguments[0];
        this._modelType = PrecisionModel.FIXED;
        this.setScale(scale);
      } else if (arguments[0] instanceof PrecisionModel) {
        var pm = arguments[0];
        this._modelType = pm._modelType;
        this._scale = pm._scale;
      }
    }
  }, {
    key: "mostPrecise",
    value: function mostPrecise(pm1, pm2) {
      if (pm1.compareTo(pm2) >= 0) return pm1;
      return pm2;
    }
  }]);
  return PrecisionModel;
}();
export { PrecisionModel as default };
var Type = /*#__PURE__*/function () {
  function Type() {
    _classCallCheck(this, Type);
    Type.constructor_.apply(this, arguments);
  }
  _createClass(Type, [{
    key: "readResolve",
    value: function readResolve() {
      return Type.nameToTypeMap.get(this._name);
    }
  }, {
    key: "toString",
    value: function toString() {
      return this._name;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [Serializable];
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      this._name = null;
      var name = arguments[0];
      this._name = name;
      Type.nameToTypeMap.put(name, this);
    }
  }]);
  return Type;
}();
Type.nameToTypeMap = new HashMap();
PrecisionModel.Type = Type;
PrecisionModel.FIXED = new Type('FIXED');
PrecisionModel.FLOATING = new Type('FLOATING');
PrecisionModel.FLOATING_SINGLE = new Type('FLOATING SINGLE');
PrecisionModel.maximumPreciseValue = 9007199254740992.0;